import React, { useState } from "react";
import { Collapse, Row, Col, Button } from "react-bootstrap";
import ToggleBtn from "../common/modals/ToggleBtn";
import ActionButtons from "components/common/tablePages/ActionButtons";
import { dateOptions } from "utils/constants";
import axios from "axiosConfig";

// Extend dayjs to accept custom formats
const SingleBrokerRow = ({
  brokerData,
  showModal,
  showRemoveBrokerModal,
  setData,
  setSelectedBroker,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  // Value of the toggle button
  // const [isChecked, setIsChecked] = useState(false);
  const { account_nickname, broker, client_id, created_at, on_off, id } =
    brokerData;
  // Toggle dropdown
  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  // Caitalize first letter of string
  const capitalizeFirstLetter = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  // Handle toggling
  const setIsChecked = async e => {
    const value = e.target.checked;
    try {
      const { data } = await axios.patch(`api/brokersetting/${id}/`, {
        on_off: value,
      });
      setData(prev => {
        const newData = [...prev];
        const index = newData.indexOf(brokerData);

        newData.splice(index, 1, data);

        return newData;
      });
    } catch (error) {
      throw new Error("Error requestiong on_off update: ", error);
    }
  };
  // A Single column component, use to avoid retyping

  const SingleCol = ({ colName, colValue }) => {
    return (
      // Set gray if toggle button is disabled
      <Col
        className={`d-flex h-auto justify-content-between mb-3 mb-lg-0 ${
          on_off ? "text-white" : "text-gray"
        }`}
        lg={2}
      >
        <p className="d-lg-none h-auto">{colName}</p>
        <p>{colValue}</p>
      </Col>
    );
  };

  const items = [
    <SingleCol colName={"Broker"} colValue={broker} key={1} />,
    <SingleCol colName={"Client ID"} colValue={client_id} key={2} />,
    <SingleCol
      colName={"Date Added"}
      colValue={new Date(created_at).toLocaleDateString("en-GB", dateOptions)}
      key={3}
    />,

    <Col
      className={`d-flex justify-content-between mb-3 mb-lg-0 ${
        on_off ? "text-white" : "text-gray"
      }`}
      lg={2}
      key={4}
    >
      <p className="d-lg-none h-auto">Off/On</p>
      <ToggleBtn isChecked={on_off} setIsChecked={setIsChecked} />
    </Col>,
    <Col
      className={`d-flex justify-content-end justify-content-lg-start`}
      lg={1}
      key={5}
    >
      <ActionButtons
        data={brokerData}
        setSelected={setSelectedBroker}
        showModal={showModal}
        showRemoveModal={showRemoveBrokerModal}
      />
    </Col>,
  ];
  return (
    <Row>
      <Col
        className={`d-lg-flex align-items-center justify-content-between lighter-section py-lg-4 px-4 mb-3`}
      >
        <Col lg={2} className="d-flex p-0">
          <div className="d-flex ">
            <p className="d-lg-none h-auto me-1 account-name">Account Name: </p>
            <p className={`m-0 d-flex account-name ${on_off ? "" : "grayed"}`}>
              {capitalizeFirstLetter(account_nickname)}
            </p>
          </div>
          <Button
            variant="link"
            onClick={toggleCollapse}
            aria-expanded={collapsed}
            className="text-white ms-auto d-lg-none"
          >
            <i className={"bi bi-chevron-" + (collapsed ? "up" : "down")}></i>
          </Button>
        </Col>
        <Col className="d-none d-lg-flex justify-content-between align-content-center">
          {items}
        </Col>

        <Col className="d-lg-none">
          <Collapse in={collapsed} className="mt-3 mt-lg-auto ">
            <Col>{items}</Col>
          </Collapse>
        </Col>
      </Col>
    </Row>
  );
};

export default SingleBrokerRow;
